/* eslint-disable @typescript-eslint/no-explicit-any */
import { useRequest } from '../hooks';

export const makeRequestHook = <Fn extends (...args: any[]) => any>(request: Fn) => {
  return () => {
    return useRequest(request);
  };
};
